let currentStep = 1;
const form = document.getElementById('armband-formular');
const steps = document.querySelectorAll('.form-step');

const selectedGems = document.getElementById('selected-gems');
const gemsDropdown = document.getElementById('gems-dropdown');

function showStep(step) {
    steps.forEach((stepDiv, index) => {
        if (index === step - 1) {
            stepDiv.style.display = 'block';
        } else {
            stepDiv.style.display = 'none';
        }
    });
}

function validateStep(step) {
    const requiredInputs = document.querySelectorAll(`#step-${step} [required]`);
    let allValid = true;

    requiredInputs.forEach(input => {
        if (!input.value) {
            input.classList.add('error'); // Markiert fehlende Felder
            allValid = false;
        } else {
            input.classList.remove('error'); // Entfernt die Markierung
        }
    });

    if (step === 1) {
        const size = document.getElementById('size').value;
        const customSize = document.getElementById('custom-size').value;
        if (size === 'custom' && !customSize) {
            alert('Bitte geben Sie eine eigene Größe ein.');
            return false;
        }
    }

    if (step === 2) {
        const faceted = document.querySelector('input[name="faceted"]:checked');
        if (!faceted) {
            alert('Bitte wählen Sie aus, ob die Perlen facettiert sein sollen.');
            return false;
        }
    }

    if (step === 3) {
        const gemCount = document.getElementById('gem-count').value;
        if (parseInt(gemCount) <= 0) {
            alert('Bitte geben Sie eine gültige Anzahl von Edelsteinen ein.');
            return false;
        }
    }

    return allValid;
}

function nextStep() {
    if (validateStep(currentStep)) {
        if (currentStep === steps.length - 1) {
            // Im letzten Schritt die Zusammenfassung anzeigen
            showSummary();
        } else {
            currentStep++;
            showStep(currentStep);
        }
    }
}

function prevStep() {
    if (currentStep > 1) {
        currentStep--;
        showStep(currentStep);
    }
}

function showSummary() {
    const summaryDiv = document.getElementById('summary');
    let summaryHTML = '<h3>Zusammenfassung</h3>';

    const size = document.getElementById('size').value;
    const customSize = document.getElementById('custom-size').value;
    const finalBead = document.querySelector('input[name="final-bead"]:checked').value;

    summaryHTML += `<p>Größe: ${size === 'custom' ? customSize : size}</p>`;
    summaryHTML += `<p>Perlengröße: ${document.getElementById('bead-size').value}</p>`;
    summaryHTML += `<p>Facettiert: ${document.querySelector('input[name="faceted"]:checked').value === 'yes' ? 'Ja' : 'Nein'}</p>`;
    summaryHTML += `<p>Anzahl Edelsteine: ${document.getElementById('gem-count').value}</p>`;
    summaryHTML += `<p>Edelsteine: ${Array.from(selectedGems.children).map(badge => badge.textContent.trim().replace('x', '')).join(', ')}</p>`;
    summaryHTML += `<p>Anordnung: ${document.getElementById('arrangement').value}</p>`;
    summaryHTML += `<p>Abschlussperle: ${finalBead === 'yes' ? 'Ja' : 'Nein'}</p>`;
    
    if (finalBead === 'yes') {
        summaryHTML += `<p>Material: ${document.getElementById('final-bead-material').value}</p>`;
    }
    
    summaryDiv.innerHTML = summaryHTML;
    showStep(steps.length); // Wechselt zu Schritt 6
}

document.getElementById('size').addEventListener('change', function () {
    const customSizeInput = document.getElementById('custom-size');
    if (this.value === 'custom') {
        customSizeInput.style.display = 'block';
    } else {
        customSizeInput.style.display = 'none';
    }
});

document.getElementsByName('final-bead').forEach(radio => {
    radio.addEventListener('change', function () {
        const finalBeadOptions = document.getElementById('final-bead-options');
        if (this.value === 'yes') {
            finalBeadOptions.style.display = 'block';
        } else {
            finalBeadOptions.style.display = 'none';
        }
    });
});

gemsDropdown.addEventListener('change', function () {
    const selectedValue = this.value;
    if (selectedValue) {
        // Überprüfen, ob der Edelstein bereits ausgewählt ist
        if (Array.from(selectedGems.children).some(badge => badge.textContent.includes(selectedValue))) {
            return;
        }

        const badge = document.createElement('div');
        badge.className = 'gem-badge';
        badge.innerHTML = `${selectedValue} <span><button class="remove-btn" onclick="removeBadge(this)">x</button></span>`;
        selectedGems.appendChild(badge);

        // Entfernt den ausgewählten Edelstein aus dem Dropdown
        Array.from(gemsDropdown.options).forEach(option => {
            if (option.value === selectedValue) {
                option.style.display = 'none';
            }
        });

        this.value = ''; // Dropdown zurücksetzen
    }
});

function removeBadge(button) {
    const badge = button.parentElement;
    const badgeText = badge.textContent.trim().replace('x', '');

    // Zeigt die entfernten Edelsteine wieder im Dropdown an
    Array.from(gemsDropdown.options).forEach(option => {
        if (option.textContent === badgeText) {
            option.style.display = 'block';
        }
    });

    badge.remove();
}

// Initialisierung
showStep(currentStep);
